import React from 'react';
import { Props } from '@components/divider/src/divider.types';
import { mergeTwClasses } from '@utils/merge-tw-classes';

export const Divider = ({ className, ...props }: Props) => (
  <div
    className={mergeTwClasses(
      'mx-auto my-6 flex w-full items-center justify-between gap-3 text-sm text-neutral-50 dark:text-neutral-0',
      className
    )}
    {...props}>
    <div className='h-[1px] w-full bg-neutral-8 dark:bg-neutral-50' />
  </div>
);
